import React from 'react';
import { withStyles } from '@material-ui/core';
import { NumericEditor } from '@dataGrid/components/cellEditors';

const styles = (theme) => ({
  container: {
    borderBottom: `1px solid ${theme.AppBGColor}`,
    color: theme.gridTextColor,
    padding: '8px 0'
  },
  title: {
    fontSize: theme.textFontSize,
    color: theme.disableButtonText,
    fontWeight: 700
  },
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
    margin: '8px 0'
  },
  flexItem: {
    fontSize: theme.textFontSize,
    fontWeight: 500
  },
  numericEditor: {
    width: '64px',
    height: '27px'
  }
});

const TrailerTypes = ({
  title,
  trailers,
  classes,
  trailerTypeCountList,
  onTrailerCountChange,
  inputRefs,
  errorClass
}) => {
  if (!trailers?.length) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>
      <div className={classes.flexContainer}>
        {trailers.map((trailer) => (
          <div key={trailer.trailerId} className={classes.flexItem}>
            <div>{trailer.trailerName}</div>
            <div className={`${classes.numericEditor} ${errorClass}`}>
              <NumericEditor
                value={
                  trailerTypeCountList.find(
                    (trailerCountObject) => trailerCountObject.trailerId === trailer.trailerId
                  )?.trailerCount ?? null
                }
                key={trailer.trailerId}
                ref={(ref) => {
                  // Passing the trailer type name along with the ref so as to easily check if it is a FME route trailer or not
                  inputRefs.current[trailer.trailerName] = {
                    ref: ref,
                    trailerTypeName: trailer.trailerTypeName
                  };
                }}
                onChange={onTrailerCountChange(trailer.trailerId)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withStyles(styles)(TrailerTypes);
